(function () {
  var root = document.querySelector("[data-assistant]");
  if (!root) return;
  document.body.appendChild(root);
  var endpoint = root.getAttribute("data-endpoint"),
      panel = root.querySelector(".mva__panel"),
      log = root.querySelector("[data-mva-log]"),
      form = root.querySelector("[data-mva-form]"),
      input = form.querySelector("input"),
      chips = root.querySelector("[data-mva-chips]"),
      KEY = "mamave_assistant", SKEY = "mamave_assistant_session",
      session = sessionStorage.getItem(SKEY) || Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  sessionStorage.setItem(SKEY, session);
  var history = [];
  try { history = JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch (e) {}

  function esc(t) { return String(t).replace(/[&<>"]/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]; }); }
  function md(t) {
    var h = esc(t).replace(/\[([^\]]+)\]\((\/[^)\s]+|https?:[^)\s]+)\)/g, '<a href="$2">$1</a>').replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>"),
        lines = h.split(/\n/), out = "", inList = false;
    lines.forEach(function (l) {
      /^\s*[-\u2022]\s+/.test(l)
        ? (inList || (out += "<ul>", inList = true), out += "<li>" + l.replace(/^\s*[-\u2022]\s+/, "") + "</li>")
        : (inList && (out += "</ul>", inList = false), l.trim() && (out += "<p>" + l + "</p>"));
    });
    if (inList) out += "</ul>";
    return out;
  }
  function add(role, text, typing) {
    var d = document.createElement("div");
    d.className = "mva__msg mva__msg--" + (role === "user" ? "user" : "bot") + (typing ? " mva__msg--typing" : "");
    d.innerHTML = role === "user" ? esc(text) : md(text);
    log.appendChild(d); log.scrollTop = log.scrollHeight;
    return d;
  }
  history.forEach(function (m) { add(m.role, m.content); });
  if (history.length && chips) chips.remove();

  function open(on) {
    panel.hidden = !on;
    root.querySelectorAll("[data-mva-toggle]")[0].setAttribute("aria-expanded", on ? "true" : "false");
    if (on) setTimeout(function () { input.focus(); }, 50);
  }
  root.querySelectorAll("[data-mva-toggle]").forEach(function (b) { b.addEventListener("click", function () { open(panel.hidden); }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) open(false); });

  function send(q) {
    q = (q || "").trim(); if (!q) return;
    if (chips) { chips.remove(); chips = null; }
    add("user", q); history.push({ role: "user", content: q });
    var wait = add("bot", "Thinking\u2026", true);
    input.value = ""; input.disabled = true;
    fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages: history.slice(-12), session: session, page: root.getAttribute("data-page") }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        wait.remove();
        var reply = j && j.ok ? j.reply : (j && j.error) || "Something went wrong. Try again, or use the contact page.";
        add("bot", reply);
        if (j && j.ok) history.push({ role: "assistant", content: reply });
        try { sessionStorage.setItem(KEY, JSON.stringify(history.slice(-20))); } catch (e) {}
      })
      .catch(function () { wait.remove(); add("bot", "I could not connect just now. Try again in a moment, or [contact us](/pages/contact-us)."); })
      .then(function () { input.disabled = false; input.focus(); });
  }
  form.addEventListener("submit", function (e) { e.preventDefault(); send(input.value); });
  root.addEventListener("click", function (e) { var c = e.target.closest("[data-mva-chip]"); if (c) { open(true); send(c.textContent); } });

  var lastHuman = parseInt(sessionStorage.getItem(KEY + "_h") || "0", 10) || 0;
  function poll() {
    if (panel.hidden || !history.length) return;
    fetch(endpoint + "?session=" + encodeURIComponent(session) + "&after=" + lastHuman, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok || !j.replies) return;
        j.replies.forEach(function (m) {
          var d = add("bot", m.answer); d.classList.add("mva__msg--human");
          var tag = document.createElement("span"); tag.className = "mva__who"; tag.textContent = "Mamave team";
          d.insertBefore(tag, d.firstChild);
          lastHuman = m.id; history.push({ role: "assistant", content: "[Team reply] " + m.answer });
        });
        if (j.replies.length) {
          try { sessionStorage.setItem(KEY + "_h", String(lastHuman)); sessionStorage.setItem(KEY, JSON.stringify(history.slice(-20))); } catch (e) {}
        }
      }).catch(function () {});
  }
  setInterval(function () { if (!panel.hidden) poll(); }, 8000);
})();
